export default {
  INIT: 'SMS/INIT',
  UPDATE_RECORD_DATA: 'SMS/UPDATE_RECORD_DATA',
  UPDATE_RECORD_META: 'SMS/UPDATE_RECORD_META',
  UPDATE_RECORD_PARAMS: 'SMS/UPDATE_RECORD_PARAMS',
}
